module.exports = __webpack_public_path__ + "125c50f9ac7102f21ebe9e61e7043e43.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Yummy/images/backgrounds/5.png
// module id = 35
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18